import {
  HelpContentService,
  ResourceProvider,
  HttpService,
} from "@sportal/api";

export const makeHelpContentService = (http: HttpService): HelpContentService =>
  new HelpContentService(new ResourceProvider(http));
